/*
 * Values references for positions :
 * undefined: not present on report, displayed as '-'
 * null: not crawled yet, displayed as '-'
 * false: crawl ended with error (for now), displayed as '-'
 * 0: position not found, displayed as '+100'
 * int: position, displayed as is
 */

/*
 * Values references for variation :
 * null: no data to display, displayed as '-'
 * true: new, displayed as 'New !'
 * false: disappeared, displayed as 'Disappeared !'
 * int: the variation, displayed as is
 */

export default () => {
  return {
    // This code is the same as the php backend: MonitorExport.getVariation
    getVariation({ last_position, position}) {
      if(position === undefined || last_position === undefined) return null
      else if(position === false || last_position === false || position === null) return null
      else if (position === last_position) return 0
      else if (position === 0) return false
      else if (last_position === 0 || last_position === null) return true
      else return parseInt(last_position) - parseInt(position)
    },

    getVariationScore({ last_position, position}) {
      if(position === undefined || last_position === undefined) return -0.5
      if(position === false || last_position === false || position === null) return -0.5
      else if (position === last_position) return 0
      else if (position === 0) return -200
      else if (last_position === 0 || last_position === null) return 200
      else return parseInt(last_position) - parseInt(position)
    },

    getPositionScore(position) {
      if(position === undefined) {
        return 220
      } else if(position === false) {
        return 210
      } else if(position === null) {
        return 190
      } else if(position === 0) {
        return 200
      } else {
        return position
      }
    },

    isUpper (a, b) {
      return this.getVariationScore(a) > this.getVariationScore(b) ? 1 : -1
    },
    isBelow (a, b) {
      return this.isUpper(a, b) * -1
    },
    isStable({ variation }) {
      return variation === 0
    },
    isGoingUp ({ variation }) {
      return variation === true || variation > 0
    },
    isGoingDown ({ variation }) {
      return variation === false || variation < 0
    }
  }
}